import { createRouter, createWebHistory } from "vue-router";
import { common } from "@/store/common";
const SegmentList = import(
  /* webpackChunkName: "SegmentList" */ "../views/Segment/SegmentList.vue"
);
const SegmentCreate = import(
  /* webpackChunkName: "SegmentCreate" */ "../views/Segment/SegmentCreate.vue"
);
const SegmentAnalytics = import(
  /* webpackChunkName: "SegmentAnalytics" */ "../views/Segment/SegmentAnalytics.vue"
);
const AddContacts = import(
  /* webpackChunkName: "AddContacts" */ "../views/Audience/AddContacts.vue"
);
const AddContactChoosetype = import(
  /* webpackChunkName: "AddContacts" */ "../views/Audience/AddContactChoosetype.vue"
);
const ImportType = import(
  /* webpackChunkName: "AddContacts" */ "../views/Audience/ImportType.vue"
);
const AddContactChooseList = import(
  /* webpackChunkName: "AddContacts" */ "../views/Audience/AddContactChooseList.vue"
);
const AudienceDetails = import(
  /* webpackChunkName: "AudienceDetails" */ "../views/Audience/AudienceDetails.vue"
);
const AudienceList = import(
  /* webpackChunkName: "AudienceList" */ "../views/Audience/AudienceList.vue"
);
const ComponentsView = import(
  /* webpackChunkName: "ComponentsView" */ "../views/ComponentsView.vue"
);
const CreateAutomation = import(
  /* webpackChunkName: "AutomationCreate" */ "../views/Automation/CreateAutomation.vue"
);
const AutomationFlowView = import(
  /* webpackChunkName: "AutomationFlow" */ "../views/Automation/AutomationFlowView.vue"
);
const ReportDetail = import(
  /* webpackChunkName: "AutomationReport" */ "../views/Automation/ReportDetail.vue"
);
const ErrorView = import(
  /* webpackChunkName: "ErrorView" */ "../views/ErrorView.vue"
);
const WebHookList = import(
  /* webpackChunkName: "WebHookList" */ "../views/Webhooks/WebHookList.vue"
);
const WebhookCreate = import(
  /* webpackChunkName: "WebhookCreate" */ "../components/Webhooks/WebhookCreate.vue"
);
const WebhookNoData = import(
  /* webpackChunkName: "WebhookNoData" */ "../components/Webhooks/WebhookNoData.vue"
);
const Security = import(
  /* webpackChunkName: "security" */ "../views/Security/SecurityView.vue"
);
const login = import(
  /* webpackChunkName: "login" */ "../views/Security/loginView.vue"
);
const users = import(
  /* webpackChunkName: "UsersList" */ "../views/Security/usersView.vue"
);
const loginSub = import(
  /* webpackChunkName: "UsersList" */ "../views/Security/loginSubUser.vue"
);
const profile = import(
  /* webpackChunkName: "UsersList" */ "../views/Security/ProfileView.vue"
);
const linkExpired = import(
  /* webpackChunkName: "linkExpired" */ "../views/Security/linkExpired.vue"
);
const PwaInstall = import(
  /* webpackChunkName: "WebhookNoData" */ "../views/pwa/pwaInstall"
);
const CreateCampaign = import(
  /* webpackChunkName: "CreateCampaign" */ "../views/Campaign/CreateCampaign.vue"
);
const ChooseContacts = import(
  /* webpackChunkName: "CreateCampaign" */ "../views/Campaign/ChooseContacts.vue"
);

const ScheduleCampaign = import(
  /* webpackChunkName: "ScheduleCampaign" */ "../views/Campaign/ScheduleCampaign.vue"
);
const ReviewCampaign = import(
  /* webpackChunkName: "ReviewCampaign" */ "../views/Campaign/ReviewCampaign.vue"
);
const AccountPreferences = import(
  /* webpackChunkName: "preferences" */ "../views/Security/AccountPreferences.vue"
);
const AutomationList = import(
  /* webpackChunkName: "AutomationList" */ "../views/Automation/AutomationList.vue"
);
const AutomationClassic = import(
  /* webpackChunkName: "AutomationClassic" */ "../views/Automation/ClassicAutomationList.vue"
);

const routes = [
  {
    path: "/automation",
    name: "AutomationClassic",
    component: () => AutomationClassic,
  },
  {
    path: "/advanced-automation",
    name: "AutomationList",
    component: () => AutomationList,
  },
  {
    path: "/account/preferences",
    name: "AccountPreferences",
    component: () => AccountPreferences,
  },
  {
    path: "/campaign/review-campaign/:id",
    name: "ReviewCampaign",
    component: () => ReviewCampaign,
  },
  {
    path: "/campaign/preview-campaign/:id",
    name: "PreviewCampaign",
    component: () => ReviewCampaign,
  },
  {
    path: "/audience/activity/campaign/:id",
    name: "AudienceCampaignActivity",
    component: () => ReviewCampaign,
  },
  {
    path: "/campaign/schedule-campaign/:id",
    name: "ScheduleCampaign",
    component: () => ScheduleCampaign,
  },
  {
    path: "/campaign/choose-contacts/:id",
    name: "ChooseContacts",
    component: () => ChooseContacts,
  },
  {
    path: "/campaign/create",
    name: "CreateCampaign",
    component: () => CreateCampaign,
  },
  {
    path: "/campaign/edit/:id",
    name: "EditCampaign",
    component: () => CreateCampaign,
  },
  {
    path: "/account/link-expired",
    name: "linkExpired",
    component: () => linkExpired,
  },
  {
    path: "/account/profile",
    name: "Profile",
    component: () => profile,
  },
  {
    path: "/account/login-subuser",
    name: "loginSub",
    component: () => loginSub,
  },
  {
    path: "/account/users-list",
    name: "users",
    component: () => users,
  },
  {
    path: "/account/login",
    name: "login",
    component: () => login,
  },
  {
    path: "/account/security",
    name: "Security",
    component: () => Security,
  },
  {
    path: "/app-install",
    name: "PwaInstall",
    component: () => PwaInstall,
  },
  {
    path: "/segments",
    name: "SegmentList",
    component: () => SegmentList,
  },
  {
    path: "/segments/create",
    name: "SegmentCreate",
    component: () => SegmentCreate,
  },
  {
    path: "/segments/edit/:id",
    name: "SegmentUpdate",
    component: () => SegmentCreate,
  },
  {
    path: "/segments/analytics/:id",
    name: "SegmentAnalytics",
    component: () => SegmentAnalytics,
  },
  {
    path: "/segments/:id/audience",
    name: "SegmentAudienceList",
    component: () => AudienceList,
  },
  {
    path: "/segments/:segmentId/audience/:id",
    name: "SegmentAudienceDetails",
    component: () => AudienceDetails,
  },
  {
    path: "/recipient-list/:id/audience",
    name: "RecipientAudienceList",
    component: () => AudienceList,
  },
  {
    path: "/audience/add-contact",
    name: "AddContacts",
    component: () => AddContacts,
    children: [
      {
        path: "",
        name: "AddContactChooseList",
        component: () => AddContactChooseList,
      },
      {
        path: "choose-type/:id",
        name: "AddContactChoosetype",
        component: () => AddContactChoosetype,
      },
    ],
  },
  {
    path: "/audience/import-contacts",
    name: "ImportContacts",
    component: () => AddContacts,
    children: [
      {
        path: "",
        name: "ImportContactChooseList",
        component: () => AddContactChooseList,
      },
      {
        path: "choose-type/:id",
        name: "ImportContactChoosetype",
        component: () => AddContactChoosetype,
      },
      {
        path: "import-type/:id",
        name: "ImportType",
        component: () => ImportType,
      },
    ],
  },
  {
    path: "/audience/details/:id",
    name: "AudienceDetails",
    component: () => AudienceDetails,
  },
  {
    path: "/webform-activity/:id",
    name: "WebformActivity",
    component: () => AudienceDetails,
  },
  {
    path: "/advanced-automations/:automationId/activity/:id",
    name: "AutomationActivity",
    component: () => AudienceDetails,
  },
  {
    path: "/recipient-list/:listId/audience/:id",
    name: "RecipientAudienceDetails",
    component: () => AudienceDetails,
  },
  {
    path: "/audience/list",
    name: "AudienceList",
    component: () => AudienceList,
  },
  {
    path: "/account/link-expired",
    name: "linkExpired",
    component: () => linkExpired,
  },
  {
    path: "/account/profile",
    name: "Profile",
    component: () => profile,
  },
  {
    path: "/account/webhooks",
    name: "WebHookList",
    component: () => WebHookList,
  },
  {
    path: "/account/webhooks/create",
    name: "WebhookCreate",
    component: () => WebhookCreate,
  },
  {
    path: "/account/webhooks/edit/:id",
    name: "WebhookEdit",
    component: () => WebhookCreate,
  },
  {
    path: "/account/webhooks/nodata",
    name: "WebhookNoData",
    component: () => WebhookNoData,
  },
  {
    path: "/advance-automation/components",
    name: "ComponentsView",
    component: () => ComponentsView,
  },
  {
    path: "/advance-automation/create/:id",
    name: "AutomationCreate",
    component: () => CreateAutomation,
    meta: {
      layout: "AppLayoutCreate",
      permissions: [0, 1, 2, 3, 4],
      requiresAuth: true,
    },
  },
  {
    path: "/advance-automation/template/:id/preview/:automationId",
    name: "AutomationTemplatePreview",
    component: () => AutomationFlowView,
    meta: {
      layout: "AppLayoutCreate",
      permissions: [0, 1, 2, 3, 4],
      requiresAuth: true,
    },
  },
  {
    path: "/advance-automation/flow/:id",
    name: "AutomationFlow",
    component: () => AutomationFlowView,
    meta: {
      layout: "AppLayoutCreate",
      permissions: [0, 1, 2, 3, 4],
      requiresAuth: true,
    },
  },
  {
    path: "/advance-automation/preview/:id",
    name: "AutomationPreview",
    component: () => AutomationFlowView,
    meta: {
      layout: "AppLayoutCreate",
      permissions: [0, 1, 2, 3, 4],
      requiresAuth: true,
    },
  },
  {
    path: "/advance-automation/report/:id",
    name: "AutomationReport",
    component: () => ReportDetail,
    meta: {
      layout: "AppLayoutCreate",
      permissions: [0, 1, 2, 3, 4],
      requiresAuth: true,
    },
  },
  {
    path: "/advance-automation/:route?",
    name: "PageNotFound",
    component: () => ErrorView,
    meta: {
      layout: "AppLayoutCreate",
      permissions: [0, 1, 2, 3, 4],
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(async (to, from) => {
  common().previousRoute = from.name;
});

// router.beforeEach(async (to, from, next) => {
// var loginData = JSON.parse(localStorage.getItem("login_data"));
// var permission = localStorage.getItem("permission");
// if (loginData && loginData.token && permission !== null) {
//   var addComplete = localStorage.getItem("address_completed");
//   if (
//     (addComplete === false || addComplete === "false") &&
//     to.name !== "RegisterAddress" &&
//     to.name !== "AdminLogin"
//   ) {
//     // showLoader();
//     next({ path: "/registration-success" });
//     return;
//   }

//   if (
//     (addComplete === true || addComplete === "true") &&
//     to.name === "RegisterAddress"
//   ) {
//     next({ name: "Dashboard" });
//     return;
//   }
// }
// if (
//   loginData &&
//   loginData.isLiftime &&
//   ["AccountPlan", "ChangePlan"].includes(to.name)
// ) {
//   next({ path: "" });
//   return;
// }
// if (to.meta.requiresAuth) {
//   if (!loginData || !loginData.token || permission === null) {
//     // showLoader();
//     next({ name: "Login" });
//   } else {
//     // showLoader();

//     if (!localStorage.getItem("is_campaign_add")) {
//       localStorage.removeItem("login_data");
//       next({ path: "/login" });
//       return;
//     }

// permission = parseInt(permission);
// if (to.meta.permissions && to.meta.permissions.indexOf(permission) < 0) {
//   next("/permission-denied");
//   return;
// }
// var expireTime = localStorage.getItem("expired_time");
// if (expireTime) {
//   expireTime = expireTime.split("_");
//   if (expireTime.length > 1) {
//     if (
//       parseInt(expireTime[0] * 1000) + parseInt(expireTime[1]) <
//       new Date().getTime()
//     ) {
//       localStorage.removeItem("login_data");
//       next({ path: "/login" });
//     }
// else {
// next();
// return;
// }
//       } else {
//         localStorage.removeItem("login_data");
//         next({ path: "/login" });
//       }
//     } else {
//       localStorage.removeItem("login_data");
//       next({ path: "/login" });
//     }
//   }
// } else if (
//   loginData &&
//   loginData.token &&
//   to.name === "Login" &&
//   permission !== null &&
//   !to.params.token
// ) {
//   // showLoader();
//   next({ path: "/dashboard" });
// } else {
//   // showLoader();
//   // next();
//   return;
// }
// });

// function showLoader() {
//   NProgress.configure({ showSpinner: false });
//   NProgress.start();
//   NProgress.inc();
// }

export default router;
